'use client';

import { Alert, Box, Stack, Typography } from '@mui/material';

import { SUPPORT_EMAIL } from '@/components/support/support';
import { Tag } from '@/components/tag';
import { useUser } from '@/contexts/useUser';

const roleLabelByName: Record<string, string> = {
  'Eon support': 'Support Admin',
  'Eon support viewer': 'Support Viewer',
};

export const SupportUserBanner = () => {
  const { user } = useUser();

  if (!user?.email?.endsWith(SUPPORT_EMAIL)) {
    return null;
  }

  const role = user.selectedRole;
  const roleLabel = roleLabelByName[role.name] ?? role.name;

  return (
    <Alert
      severity='warning'
      variant='filled'
      icon={<i className='material-symbols-verified-user-outline-rounded' />}
      sx={{
        borderRadius: '0px',
        padding: '6px 16px',
        '& .MuiAlert-message': { width: '100%' },
        '& .MuiAlert-icon': { alignItems: 'center' },
      }}
    >
      <Stack
        direction='row'
        sx={{ gap: '8px', alignItems: 'center', width: '100%' }}
      >
        <Typography variant='subtitle2Strong' sx={{ color: 'inherit' }}>
          You are signed in as Eon Support
        </Typography>
        <Box sx={{ marginLeft: 'auto' }}>
          <Tag content={roleLabel} />
        </Box>
      </Stack>
    </Alert>
  );
};
